"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var WixMarketplace = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M7,20 L7,19 L10,19 L10,16 L4,16 C3.44771525,16 3,15.5522847 3,15 L3,14.5 C3,12.1664501 4.4532732,10.1723304 6.50413179,9.37332866 C5.59502632,8.74331189 5,7.69114387 5,6.5 C5,4.56700338 6.56700338,3 8.5,3 C10.4329966,3 12,4.56700338 12,6.5 C12,7.69114387 11.4049737,8.74331189 10.4959467,9.37547837 C11.7556964,9.86496728 12.7899841,10.8062306 13.4004515,12.0004297 L19,12 C19.5522847,12 20,12.4477153 20,13 L20,19 C20,19.5522847 19.5522847,20 19,20 L7,20 Z M19,13 L11,13 L11,19 L19,19 L19,13 Z M8.5,4 C7.11928813,4 6,5.11928813 6,6.5 C6,7.70968176 6.85916789,8.7186941 8.00057405,8.9501074 L8.00029704,10.0274316 C5.7501788,10.2760186 4,12.1836212 4,14.5 L4,15 L10,15 L10,13 C10,12.4477153 10.4477153,12 11,12 L12.2422723,12.0000699 C11.5225845,10.9248689 10.3518194,10.1771163 9.00070744,10.0275426 L9.00043449,8.94990271 C10.1413382,8.71809967 11,7.70932545 11,6.5 C11,5.11928813 9.88071187,4 8.5,4 Z" })));
};
WixMarketplace.displayName = 'WixMarketplace';
exports.default = WixMarketplace;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=WixMarketplace.js.map